/* Author: Soumya Shreyas
 */

import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { BiTrash, BiUpload, BiChevronRight } from "react-icons/bi";
import { FcFolder, FcImageFile, FcDocument, FcFile } from "react-icons/fc";
import { Breadcrumb, Button, Modal } from "react-bootstrap";
import moment from "moment";
import DmsService from "../../../core/service/DmsService";
import Admin_folder from "../../../images/Admin_folder.svg";
import New_Folder from "../../../images/New_Folder.svg";
import Share_folder from "../../../images/Share_folder.svg";
import "../DocumentModal.scss";

function Folder({ t, folder, callbackFolder, deleteFolder, regulation }) {
  const [showInfo, setShowInfo] = useState(false);
  const [show, setShow] = useState(false);
  const [showDelMsg, setShowDelMsg] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [rename, setRename] = useState("");
  // const [docRename, setDocRename] = useState(folder.name);
  const handleClose = () => setShow(false);
  const handleDelMsgClose = () => setShowDelMsg(false);
  const handleRenameClose = () => setShowRename(false);
  const [selDoc, setSelDoc] = useState("");
  const [showRename, setShowRename] = useState(false);
  const [docRename, setDocRename] = useState(folder.name);

  // useEffect(() => {
  //   document.addEventListener("click", handleClickOuter);
  //   return () => {
  //     document.removeEventListener("click", handleClickOuter);
  //   };
  // });

  const handleClick = (e, item) => {
    e.preventDefault();
    let id = item.id;
    let folderName = item.name;

    const obj = {
      id: id,
      folderName: folderName,
      type: e.detail,
      isDoc: item.code ? false : true,
    };
    if (e.type === "contextmenu") {
      setShowInfo(!showInfo);
    } else if (e.type === "click") {
      setShowCheck(!showCheck);
      showInfo && setShowInfo(false);
    }
    if (e.detail === 1) {
      setSelDoc(id);
      callbackFolder(obj);
      // selDoc ? setSelDoc(id) : setSelDoc("");
    } else if (e.detail === 2) {
      callbackFolder(obj);
    }
  };
  const handleClickOuter = useCallback(() => {
    setShowInfo(false);
    // setSelDoc("");
  }, []);
  const handleDelete = (e, item) => {
    e.preventDefault();
    setShow(true);
    setShowInfo(false);
    setDeleteItem(item);
  };

  const handleSelection = (e, id) => {
    // setSelCheck(id);
  };
  const handleRename = (e, item) => {
    e.preventDefault();
    setRename(item);
    setShowRename(true);
    setShowInfo(false);
  };
  // const handleConfirm = (e) => {
  //   e.preventDefault();
  //   setShow(false);
  //   deleteFolder(deleteItem);
  // };
  const handleMouseLeave = () => {
    showInfo && setShowInfo(false);
  };
  const handleConfirm = (e) => {
    e.preventDefault();
    setShow(false);
    var params = {
      id: deleteItem.id,
    };
    DmsService.deleteRegulationDoc(regulation, deleteItem.id)
      .then((response) => {
        if (response.status === 204) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }

        deleteFolder(deleteItem);
      })
      .catch((error) => { });
  };
  const handleRenameConfirm = (e) => {
    e.preventDefault();
    setShowRename(false);
    folder.name = docRename;
    DmsService.updateRegulationDoc(regulation, folder.id, folder)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          callbackFolder(folder.container.id, folder.container.name);
        }
      })
      .catch((error) => { });
  };
  const changeClassName = (id = "") => {
    const collection = document.getElementsByClassName(
      "Single_DMSFiles_inner active"
    );
    if (collection.length > 0) {
      collection[0].className = "Single_DMSFiles_inner";
    }
    let docId = selDoc;
    let classes = "Single_DMSFiles_inner";
    classes += docId === id ? " active" : "";

    return classes;
  };

  // const handleCheckbox = () => setShowCheck(!showCheck);
  return (
    <>
      {/* {dir?.map((folder) => ( */}

      <div
        className="Single_DMSFiles"
        key={folder.id}
        onClick={(e) => handleClick(e, folder)}
        onContextMenu={(e) => handleClick(e, folder)}
        onMouseLeave={handleMouseLeave}
      >
        {/* <input type="radio" value={folder.id} name={folder.id}  onClick={(e) => handleSelection(e, folder.id)} />  */}
        {/* <input
          className="form-check-input"
          type="radio"
          name="folder"
          value={folder.id}
            checked={showCheck}
            onChange={handleCheckbox}
        /> */}
        {/* <div  className={`Single_DMSFiles_inner ${selDoc === folder.id ? "active" : ""}`} > */}
        <div className={changeClassName(folder.id)}>
          <div className="Single_DMSFiles_icon">
            <img
              src={folder.global ? Admin_folder : New_Folder}
              alt={folder.global ? Admin_folder : New_Folder}
              onClick={(e) => handleClick(e, folder)}
              onContextMenu={(e) => handleClick(e, folder)}
            />
          </div>
          <div className="S-DMSF-Title">{folder.name}</div>
          {showInfo && (
            <div className="S-DMSF_info">
              <ul>
                {/* <li>
                      <a href="#">New Folder</a>
                    </li> */}
                {folder.canEdit && (
                  <li>
                    <Link to="#" onClick={(e) => handleRename(e, folder)}>
                      {t("Rename.label")}
                    </Link>
                  </li>
                )}
                <li>
                  <Link to="#">
                    {t("Information.label")} <BiChevronRight />
                  </Link>
                  <div className="Information_Folder">
                    <p>
                      {t("CreatedOn.label")} :{" "}
                      <b>
                        {" "}
                        {moment(folder.createdDate).format("MMM DD, YYYY")}
                      </b>
                    </p>
                    <p>
                      {t("LastModified.label")} :{" "}
                      <b>
                        {" "}
                        {moment(folder.lastModifiedDate).format("MMM DD, YYYY")}
                      </b>
                    </p>
                    {/* <p>
                        {t("NoofItems.label")} : <b>2</b>
                      </p> */}
                  </div>
                </li>
                {folder.canEdit && (
                  <li>
                    <Link to="#" onClick={(e) => handleDelete(e, folder)}>
                      {t("Delete.label")}
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
      {/* ))} */}
      <Modal show={show} onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{t("ConfirmDeleteFolder.label")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Close.label")}
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            {t("Confirm.label")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showRename} onHide={handleRenameClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="p-2">
            <label className="mb-1">{t("EnterFolderName.label")}</label>
            <input
              type="text"
              className="form-control"
              value={docRename}
              onChange={(e) => setDocRename(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleRenameClose}>
            {t("Close.label")}
          </Button>
          <Button variant="primary" onClick={(e) => handleRenameConfirm(e)}>
            {t("Confirm.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default withTranslation()(Folder);
